import React from 'react';
import logout from '../../assets/img/logout.svg'

import { Link } from 'react-router-dom'
import { Menu, Button } from 'semantic-ui-react'

import { onSignOut } from '../../Auth'

import  logo  from '../../assets/img/Knauf_Insulation_Logo.png'

class Header extends React.Component{

    signOut() {
        onSignOut();
    }

    render(){
        return(
                <div className="ui stackable menu">
                <a href="/" className="item"><img src={logo} style={{ width: '9em' }} /></a>
                    <div className="ui simple dropdown item">              
                        <a href="/home" className="item">
                        Accueil
                        </a>
                    </div>
                    <div className="ui simple dropdown item">
                        <a href="/comptes" className="item">
                        Comptes
                        </a>
                    </div>
                    <div className="ui simple dropdown item">
                        <a href="/produits" className="item">
                        Produits
                        </a>
                    </div>

                    <div className="ui simple dropdown item">
                        <a href="/email" className="item">
                        Emails
                        </a>
                    </div>

                    <Menu.Menu position='right'>
                        <Menu.Item>
                            <Link to='/' ><Button fluid basic onClick={this.signOut} >Se Deconnecter</Button></Link>
                        </Menu.Item>
                    </Menu.Menu> 

                </div>

);
}

}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Protected/Header.jsx